// ----------------------------------------------------------------------------
// Template: Collection
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/card/card';
import 'snippets/pagination/pagination';
import 'snippets/collection-driver/collection-driver';
import 'snippets/collection-filters-sort/collection-filters-sort';
import 'sections/page-hero/page-hero';
import 'sections/main-collection/main-collection';
import 'sections/main-list-collections/main-list-collections';
import 'sections/footer/footer';